export enum UserLocalStorageKey {
  // graph zoom
  GraphZoom = "graph_zoom",

  // base URL
  BaseURL = "base_url",

  // simple loading state
  InsulinsLoadedBefore = "insulins_loaded_before_4_3",
  AccountInsulinsLoadedBefore = "account_insulins_loaded_before_4_3",
  MedicationsLoadedBefore = "medications_loaded_before_4_3",
  AccountMedicationsLoadedBefore = "account_medications_loaded_before_4_3",
  EntryTemplatesLoadedBefore = "entry_templates_loaded_before_4_3",

  // aggregated paginated loading states
  EventsLoadedRanges = "events_loaded_ranges_4_3",
  EntriesLoadedRanges = "entries_loaded_ranges_4_3",

  // database last trimmed dates
  EntriesLastTrimmedAt = "entries_last_trimmed_at_4_3", // TODO
  EventsLastTrimmedAt = "events_last_trimmed_at_4_3", // TODO
}

export enum GlobalLocalStorageKey {
  CountryCodeSelection = "country_code_selection",
  TrackingTechnologyConsentResponse = "tracking_technology_consent_response",
}

export type LocalStorageKey = (UserLocalStorageKey | GlobalLocalStorageKey) & string
